import { AxiosResponse } from 'axios';
import { ActCategory } from 'shell/models/act-category-list';
import { HttpResponse } from 'shell/models/http-response';
import { RegistrationCitizenshipFormVM } from 'mutation/view-models/registration-citizenship';
import { transformEditDataControl } from './transform-edit-data-control';
import { transformNewCitizenship } from './transform-new-citizenship';

export const transformCitizenship = (
  response: AxiosResponse<HttpResponse<ActCategory>>
): RegistrationCitizenshipFormVM => {
  const castedRes = response.data.payload.consultazioneANSCResponse?.modelEventoDTO || [];
  const modelEventoDTO = castedRes[0] || {};

  const datiAggiuntiviSide = response.data.payload.datiAggiuntiviSide || {};

  const editDataControl = transformEditDataControl(modelEventoDTO);

  const newCitizenship = transformNewCitizenship(datiAggiuntiviSide);

  return {
    editDataControl,
    newCitizenship,
    modelEventoDTO,
    datiAggiuntiviSide,
  };
};
